export default {
    CONSUMO_INTERNO: 1,
    QUEBRADO: 2,
    VENCIDO: 3,
}